import * as React from 'react';
import * as styles from './create-segment.module.scss';
import Paths from '../../models/enums/paths';
import { Route, Switch, useParams } from 'react-router-dom';
import { useSegment } from '../../hooks/useSegment';
import SegmentBreadcrumbs from './breadcrumbs/segment-breadcrumbs';
import SegmentationPermission from '../../models/enums/segmentationPermission';
import SegmentMenu from './segment-menu';
import PushHistoryDetails from './push-segment/push-history-details';
import useUser from '../../hooks/useUser';
import Segment from './segment';
import ViewSegment from './view-segment';
import SegmentDependenciesTable from './segment-dependencies/segment-dependencies-table';

const SegmentTab = () => {
  const { segmentId } = useParams<{ segmentId: string }>();
  const currentPath = Paths.Segment.replace(':segmentId', segmentId);
  const { segmentQuery } = useSegment(segmentId);

  const [pushUser, setPushUser] = React.useState<boolean>(false);
  const [powerUser, setPowerUser] = React.useState<boolean>(false);
  const [clientIdForSegment, setClientIdForSegment] = React.useState<number | null>(null);
  const { getCurrentUser } = useUser();
  const userName = React.useRef<string>('');
  const userInterface = window.env.USER_INTERFACE ?? 'default';

  React.useEffect(() => {
    if (segmentQuery.data) {
      void checkUser();
    }
  }, [segmentQuery.data]);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      userName.current = `${currentUser.firstName} ${currentUser.lastName}`;
      const assignedSegmentation = currentUser.assignedSegmentation.find(
        (as) => as.clientId === segmentQuery.data.clientId
      );
      setClientIdForSegment(segmentQuery.data.clientId);
      setPushUser(assignedSegmentation.segmentationPermission === SegmentationPermission.Push);
      setPowerUser(assignedSegmentation.segmentationPermission === SegmentationPermission.Power);
    } catch (error) {
      setClientIdForSegment(null);
      setPushUser(false);
      setPowerUser(false);
    }
  };

  return (
    <div className={styles.root}>
      <>
        <SegmentBreadcrumbs />
        <SegmentMenu segmentId={segmentId} />
      </>
      <div>
        <Switch>
          <Route exact path={Paths.Segment}>
            {userInterface !== 'management' && (
              <Segment
                segmentId={segmentId}
                segmentQuery={segmentQuery}
                powerUser={powerUser}
                userName={userName.current}
              />
            )}
            {userInterface === 'management' && (
              <ViewSegment
                segmentId={segmentId}
                segmentQuery={segmentQuery}
                powerUser={powerUser}
                userName={userName.current}
              />
            )}
          </Route>
          <Route exact={true} path={`${currentPath}/pushes`}>
            <PushHistoryDetails
              segmentId={segmentId}
              canPush={pushUser || powerUser}
              clientIdForSegment={clientIdForSegment}
            />
          </Route>
          <Route exact={true} path={`${currentPath}/dependencies`}>
            <SegmentDependenciesTable segmentId={segmentId} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default SegmentTab;
